import { render, staticRenderFns } from "./LabelsList.vue?vue&type=template&id=1e3d4baa&scoped=true"
import script from "./LabelsList.vue?vue&type=script&lang=ts"
export * from "./LabelsList.vue?vue&type=script&lang=ts"
import style0 from "./LabelsList.vue?vue&type=style&index=0&id=1e3d4baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d4baa",
  null
  
)

export default component.exports